import { Tab } from "@headlessui/react";
import React, {
  useCallback,
  Fragment,
  useEffect,
  useMemo,
  useRef,
  useState,
  ChangeEvent,
} from "react";
import TabsMobile from "../__template/TabsMobileComponent";
import invoice from "../../assets/images/icon_invoice/invoice.svg";
import discount from "../../assets/images/icon_invoice/discount.svg";
import paymentSuccess from "../../assets/images/icon_invoice/payment-success.svg";
import {
  downloadSummary,
  getAllInvoice,
  getAllInvoicePaid,
  getAllInvoiceSummary,
  invoicePayment,
} from "../../core/service/api_invoice";
import { formatCurrency, numberWithCommas } from "../../config/global";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import { setLoading } from "../../core/feature/config/configSlice";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import "react-spring-bottom-sheet/dist/style.css";
import { BottomSheet } from "react-spring-bottom-sheet";
import User, { Balance } from "../../core/models/user";
import { toast } from "react-toastify";
import { getBalance } from "../../core/service/api_balance";
import { RWebShare } from "react-web-share";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/user/balanceSlice";
import { removeUser } from "../../core/feature/user/userSlice";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import * as htmlToImage from "html-to-image";
import CustomApp from "../../core/models/customApp";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import { isDarkColor } from "../../config/DarkColorChecker";
import { downloadBase64 } from "../../config/iosBridge";
import { Dialog, Transition } from "@headlessui/react";

const ComponentInvoice = () => {
  const gaEventTracker = useAnalyticsEventTracker("Transaction");

  const user: User = useAppSelector((state) => state.user.user);
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [invoices, setInvoices] = useState<any>([]);
  const [invoicePaid, setInvoicePaid] = useState<any>([]);
  const [invoiceSummary, setInvoiceSummary] = useState<any>([]);
  const [detailPaymentSuccess, setDetailPaymentSuccess] = useState<any>([]);
  const [invoiceDetail, setInvoiceDetail] = useState<any>([]);
  const [invoiceDetailHistory, setInvoiceDetailHistory] = useState<any>([]);
  const [openDetailInvoice, setOpenDetailInvoice] = useState(false);
  const [openSorting, setOpenSorting] = useState(false);
  const [openPaymentSuccessInvoice, setOpenPaymentSuccessInvoice] =
    useState(false);
  const [openDetailHistory, setOpenDetailHistory] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isShowMore, setIsShowMore] = useState(false);
  const [showDescription, setShowDescription] = useState(true);
  const inputAmount = useRef<HTMLInputElement>(null);
  const [amount, setAmount] = useState("");
  const [page, setPage] = useState(0);
  const [indexes, setIndexes] = useState(0);
  const [size, setSize] = useState(10);
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  let [isOpen, setIsOpen] = useState(false);
  const ref2 = useRef<HTMLDivElement>(null);
  var invoicea = `${t("INVOICE.title")}`;
  var history = `${t("INVOICE.history")}`;
  var summary = `${t("INVOICE.summary")}`;
  var placeholder = `${t("INVOICE.placeholder")}`;
  const [sortBy, setSortBy] = useState('invoiceDate_Desc')
  let [categories] = useState({
    [invoicea]: [],
    [history]: [],
    [summary]: [],
  });

  const sortingOptions = [
  { label: t('SORTING.invoiceDateDesc'), value: "invoiceDate_Desc" },
  { label: t('SORTING.invoiceDateAsc'), value: "invoiceDate_Asc" },
  { label: t('SORTING.dueDateAsc'), value: "dueDate_Asc" },
  { label: t('SORTING.dueDateDesc'), value: "dueDate_Desc" },
  { label: t('SORTING.amountAsc'), value: "amount_Asc" },
  { label: t('SORTING.amountDesc'), value: "amount_Desc" }
];

  const shareButton = useRef<HTMLButtonElement>(null);
  const [url, setUrl] = useState<string>("none"); // Unfortunately, we have to have a dummy string here, or FacebookShareButton will blow up.

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  const paymentAction = async () => {
    setOpenDetailHistory(false);
    setOpenDetailInvoice(false);
    setIsOpen(true);
  };
  const closeAction = async () => {
    setIsOpen(false);
  };
  const download = async () => {
    downloadSummary()
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `summary_invoice_${moment().format("ll")}.xls`
        );
        document.body.appendChild(link);
        link.click();

        // toast.success("Sukses Unduh File");
      })
      .catch((err) => {});
  };

  const handleSortChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPage(0);
    const sortData = e.target.value
      setSortBy(sortData)
  }
  const getInvoice = async () => {
    dispatch(setLoading(true));
    const sort = sortBy.split('_')
    getAllInvoice(size, page, sort[0],sort[1], "", "")
      .then((res: any) => {
        dispatch(setLoading(false));
        setInvoices(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const addMoreInvoice = async () => {
    setPage(page + 1);
    dispatch(setLoading(true));
    const sort = sortBy.split('_')
    getAllInvoice(size, page + 1, sort[0],sort[1], "", "")
      .then((res) => {
        dispatch(setLoading(false));
        setInvoices(invoices.concat(res.data.content));
        console.log(res.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };

  const getInvoicePaid = async () => {
    dispatch(setLoading(true));
    getAllInvoicePaid(10, 0, "Desc", "", "")
      .then((res: any) => {
        dispatch(setLoading(false));
        setInvoicePaid(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const addMoreInvoicePaid = async () => {
    setPage(page + 1);

    dispatch(setLoading(true));
    getAllInvoicePaid(size, page + 1, "Desc", "", "")
      .then((res) => {
        dispatch(setLoading(false));
        setInvoicePaid(invoicePaid.concat(res.data.content));
        console.log(res.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };
  const getInvoiceSummary = async () => {
    dispatch(setLoading(true));
    getAllInvoiceSummary(size, 0, "Desc", "", "")
      .then((res: any) => {
        dispatch(setLoading(false));
        setInvoiceSummary(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const addMoreInvoiceSummary = async (type: String) => {
    dispatch(setLoading(true));

    if (type == "prev") {
      setPage(page - 1);
      setIndexes(indexes - 10);
      getAllInvoiceSummary(size, page - 1, "Desc", "", "")
        .then((res) => {
          dispatch(setLoading(false));
          setInvoiceSummary(res.data.content);
          console.log(res.data);
        })
        .catch((err) => {
          dispatch(setLoading(false));
        });
    } else {
      setPage(page + 1);
      setIndexes(indexes + 10);
      getAllInvoiceSummary(size, page + 1, "Desc", "", "")
        .then((res) => {
          dispatch(setLoading(false));
          setInvoiceSummary(res.data.content);
          console.log(res.data);
        })
        .catch((err) => {
          dispatch(setLoading(false));
        });
    }
  };

  const currentSizeInvoice = useMemo(() => {
    const a = invoices.length;
    const b = a / (page + 1);
    console.log("b", a, b);

    return b;
  }, [invoices]);

  const currentSizeInvoicePaid = useMemo(() => {
    const a = invoicePaid.length;
    const b = a / (page + 1);
    console.log("b", a, b);

    return b;
  }, [invoicePaid]);

  const currentSizeInvoiceSummary = useMemo(() => {
    const a = invoiceSummary.length;
    return a;
  }, [invoiceSummary]);

  function onDismissDetailInvoice() {
    setOpenDetailInvoice(false);
  }

  function onDismissDetailHistory() {
    setOpenDetailHistory(false);
  }

  function onDismissPaymentSuccessInvoice() {
    window.scrollTo(0, 0);
    setOpenPaymentSuccessInvoice(false);
  }

  function onDismissSorting() {
    setOpenSorting(false);
  }

  const openSheetDetailInvoice = async (data: any) => {
    setIsShowMore(false);
    setOpenDetailInvoice(true);
    console.log(data);
    setAmount("");
    setInvoiceDetail(data);
    if (data?.partialMethod == true) {
      // jika sisa nya memang kurang dari sama dengan 10k, langsung di inputin sisa nya dan disable changes
      if (data?.amount - data?.paidAmount <= 10000) {
        setAmount(String(data?.amount - data?.paidAmount));
        setIsActive(false);
      } else {
        setIsActive(true);
      }
    } else {
      setIsActive(false);
    }
    // setInvoiceDetail(data);
  };
  const openSheetDetailHistory = async (data: String) => {
    setOpenDetailHistory(true);
    setInvoiceDetailHistory(data);
  };


  const openSortingMenu = () => {
    setOpenSorting(true);
  }

  const paymentInvoice = async (data: any) => {
    onDismissDetailInvoice();
    var unpaidAmount = data.amount - data.paidAmount;

    var tempAmount;
    // console.log(unpaidAmount)

    if (data.partialMethod == true) {
      // jika yang dibayar melebihi yang harus dibayar
      if (parseInt(amount) > unpaidAmount)
        return toast.warning(
          t("INVOICE.amountNotValid") + formatCurrency(unpaidAmount)
        );
      //   );
      // if (parseInt(amount) < 10000 && unpaidAmount > 10000)
      //   return toast.warning(t("INVOICE.placeholder"));
      // if (balance < parseInt(amount))
      //   return toast.warning(t("INVOICE.balanceEmpty") + formatCurrency(balance));

      // jika sisa setelah bayar, kurang dari 10k
      if (
        unpaidAmount - parseInt(amount) < 10000 &&
        unpaidAmount > 10000 &&
        unpaidAmount != parseInt(amount)
      )
        return toast.warning(t("INVOICE.remainingPayment"));

      // if ( (unpaidAmount - parseInt(amount)) < 10000 && parseInt(amount) != unpaidAmount)
      //   return toast.warning(t("INVOICE.amountNotEqualToInvoice").replace("<sekian>", formatCurrency(unpaidAmount)));

      if (parseInt(amount) > unpaidAmount)
        return toast.warning(
          t("INVOICE.amountNotValid") + formatCurrency(unpaidAmount)
        );
      if (parseInt(amount) < 10000 && unpaidAmount > 10000)
        return toast.warning(t("INVOICE.placeholder"));
      if (balance < parseInt(amount))
        return toast.warning(
          t("INVOICE.balanceEmpty") + formatCurrency(balance)
        );

      tempAmount = amount;
    } else {
      if (balance < unpaidAmount)
        return toast.warning(
          t("INVOICE.balanceEmpty") + formatCurrency(balance)
        );

      tempAmount = unpaidAmount.toString();
    }
    var query = {
      amount: parseInt(tempAmount),
      cash: true,
      channel: "MOBILE",
      invoiceId: data.invoiceId,
      tag: "",
    };
    console.log(query);

    console.log("jadi");

    dispatch(setLoading(true));
    invoicePayment(query)
      .then((res) => {
        setOpenDetailInvoice(false);
        setDetailPaymentSuccess(res.data);
        setOpenPaymentSuccessInvoice(true);
        setIsOpen(false);
        dispatch(setLoading(false));
        getInvoice();
        getBalance()
          .then((res) => {
            dispatch(setBalance(res.data.balance));
          })
          .catch((err) => {
            dispatch(removeUser());
            dispatch(removeBalance());
            navigate("/login", { replace: true });
          });
        gaEventTracker("Click Payment", "Payment Invoice Success");

        toast.success(t("INVOICE.success"), { autoClose: 6000 });
      })
      .catch((err: any) => {
        console.log(err);

        dispatch(setLoading(false));
      });
  };

  const onClick = async () => {
    dispatch(setLoading(true));
    setShowDescription(false);
    // Be sure to check for the "none" state, so we don't trigger an infinite loop.
    if (url === "none") {
      if (ref.current === null) {
        return;
      }

      htmlToImage
        .toPng(ref.current, { cacheBust: true })
        .then((dataUrl) => {
          if (localStorage.getItem("device")?.includes("ios")) {
            downloadBase64(dataUrl);
            dispatch(setLoading(false));
            setShowDescription(true);
          } else {
            var link = document.createElement("a");
            link.href = dataUrl;
            console.log(dataUrl, "sukses");
            var iframe =
              "<iframe width='100%' height='100%' src='" +
              dataUrl +
              "'></iframe>";

            const linkSource = dataUrl;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download =
              invoiceDetail?.title + " - " + invoiceDetail?.callerName;
            downloadLink.click();

            dispatch(setLoading(false));
            setShowDescription(true);
            // link.click();
          }
        })
        .catch((err) => {
          console.log(err);

          dispatch(setLoading(false));
          setShowDescription(true);
        });
    }
  };
  const ondownload = async () => {
    dispatch(setLoading(true));
    setShowDescription(false);
    setTimeout(() => {
      downloadImage();
    }, 1000);
    // Be sure to check for the "none" state, so we don't trigger an infinite loop.
  };

  const downloadImage = async () => {
    if (url === "none") {
      if (ref2.current === null) {
        return;
      }
      htmlToImage
        .toPng(ref2.current, { cacheBust: true })
        .then((dataUrl) => {
          var link = document.createElement("a");
          link.href = dataUrl;
          console.log(dataUrl, "sukses");
          var iframe =
            "<iframe width='100%' height='100%' src='" +
            dataUrl +
            "'></iframe>";

          const linkSource = dataUrl;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download =
            invoiceDetailHistory?.title +
            " - " +
            invoiceDetailHistory?.callerName;
          downloadLink.click();

          dispatch(setLoading(false));
          setShowDescription(true);
          // link.click();
        })
        .catch((err) => {
          console.log(err);

          dispatch(setLoading(false));
          setShowDescription(true);
        });
    }
  };

  // Whenever "url" changes and we re-render, we manually fire the click event on the button, and then re-set the url.
  useEffect(() => {
    if (url !== "none") {
      shareButton.current?.click();
      setUrl("none");
    }
  }, [url, shareButton]);

useEffect(() => {
  if (sortBy) {
    getInvoice();
    onDismissSorting();
  }
}, [sortBy]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (activeTab == 0) {
      setPage(0);
      getInvoice();
    } else if (activeTab == 1) {
      setPage(0);
      getInvoicePaid();
    } else {
      setPage(0);
      getInvoiceSummary();
    }
  }, [activeTab]);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className="bg-white px-8 pt-8 pb-3  sticky top-0">
        <TabsMobile
          name={`${t("INVOICE.title")}`}
          backUrl={"home"}
        ></TabsMobile>
      </div>
      {/* bottom detail paid invoice */}
      <BottomSheet
        open={openDetailHistory}
        onDismiss={onDismissDetailHistory}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.6,
        ]}
        header={
          <h1 className="font-poppins flex items-left text-sm  font-bold text-black">
            {invoiceDetailHistory?.title}
          </h1>
        }
        footer={
          <div className="flex flex-col gap-2 z-[1000]">
            {/* <button className="disabled:bg-psp-gray w-full bg-white shadow-lg  text-psp-primary  border-1 border-psp-primary border-solid py-2.5 text-sm font-semibold rounded-lg">
            {t("INVOICE.share")}
          </button> */}
            <button
              onClick={ondownload}
              style={{ backgroundColor: customApp?.app_accent_color }}
              className={`disabled:bg-psp-gray w-full  shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp.app_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("INVOICE.download")}
            </button>
            <button
              onClick={() => onDismissDetailHistory()}
              style={{ backgroundColor: customApp?.app_secondary_accent_color }}
              className={`disabled:bg-psp-gray w-full shadow-lg  py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp.app_secondary_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("OTHER.close")}
            </button>
          </div>
        }
      >
        <div className="px-4 py-2 bg-white" ref={ref2}>
          {invoiceDetailHistory?.description != "" && showDescription && (
            <div>
              {invoiceDetailHistory?.description && (
                <div
                  className="font-poppins font-normal text-sm text-psp-nav text-justify"
                  dangerouslySetInnerHTML={{
                    __html:
                      invoiceDetailHistory?.description?.length > 100 &&
                      !isShowMore
                        ? invoiceDetailHistory?.description
                            .replaceAll(/\n/g, "<br>")
                            .substring(0, 100) + "..."
                        : invoiceDetailHistory?.description.replaceAll(
                            /\n/g,
                            "<br>"
                          ),
                  }}
                ></div>
              )}

              <h1 className="font-poppins font-normal text-sm text-psp-nav text-justify">
                {invoiceDetailHistory?.description?.length > 100 && (
                  <span
                    className="text-blue-600 underline cursor-pointer"
                    onClick={() => setIsShowMore(!isShowMore)}
                  >
                    {isShowMore ? t("INVOICE.showLess") : t("INVOICE.showMore")}
                  </span>
                )}
              </h1>
            </div>
          )}
          <h1 className="font-poppins font-medium text-sm text-black my-2">
            Data Pembayaran
          </h1>
          <div
            className={`grid grid-cols-2 gap-1 ${
              user.name === invoiceDetailHistory?.callerName ? "hidden" : ""
            }`}
          >
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.parentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
              <div className="grow text-right">{user.name}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.studentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
              <div className="font-poppins grow text-right">
                {invoiceDetailHistory?.callerName}
              </div>
            </div>
          </div>
          <div>
            <h1 className="font-poppins font-medium text-sm text-black my-2">
              {t("INVOICE.detailInvoice")}
            </h1>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceName")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
                <div className="grow text-right">
                  {invoiceDetailHistory?.title}
                </div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.date")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(invoiceDetailHistory?.invoiceDate).format("LL")}
                </div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.limit")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(invoiceDetailHistory?.dueDate).format("LL")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceType")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetailHistory?.partialMethod == false
                    ? t("INVOICE.cash")
                    : t("INVOICE.credit")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  Status
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetailHistory?.status == "UNPAID"
                    ? t("INVOICE.unpaid")
                    : invoiceDetailHistory?.status == "PAID"
                    ? t("INVOICE.paid")
                    : t("INVOICE.partial")}
                </div>
              </div>
            </div>
            <div hidden={!invoiceDetailHistory.showDetail}>
              {invoiceDetailHistory?.detail?.map((res: any) => (
                <div className="grid grid-cols-2 gap-1">
                  <div className="flex flex-row">
                    <h1 className="font-poppins font-normal text-sm text-psp-nav">
                      {res.title}
                    </h1>
                  </div>
                  <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                    <div className="grow text-right">
                      {formatCurrency(res.amount)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <hr />
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.total")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  invoiceDetailHistory?.amount -
                    invoiceDetailHistory?.paidAmount
                )}
              </div>
            </div>
          </div>
        </div>
      </BottomSheet>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeAction}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("INVOICE.confirm")}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      {t("INVOICE.paymentConfirm")}
                    </p>
                  </div>

                  <div className="mt-4 flex gap-2 justify-center">
                    <button
                      type="button"
                      className="active:bg-zinc-100 inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={() => closeAction()}
                    >
                      {t("OTHER.no")}
                    </button>
                    <button
                      type="button"
                      className="active:bg-psp-hover active:text-white inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={() => paymentInvoice(invoiceDetail)}
                    >
                      {t("OTHER.yes")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      {/* bottom detail unpaid invoice */}
      <BottomSheet
        open={openDetailInvoice}
        onDismiss={onDismissDetailInvoice}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.6,
        ]}
        header={
          <h1 className="font-poppins flex items-left text-sm  font-bold text-black">
            {invoiceDetail?.title}
          </h1>
        }
        footer={
          <button
            onClick={() => {
              paymentAction();
            }}
            // onClick={() => paymentInvoice(invoiceDetail)}
            disabled={isActive}
            style={{
              backgroundColor: isActive ? "gray" : customApp?.app_accent_color,
            }}
            className={`disabled:bg-psp-gray w-full  shadow-lg shadow-psp-primary py-2.5 text-sm font-semibold rounded-lg ${
              isDarkColor(customApp.app_accent_color)
                ? "text-white"
                : "text-black"
            }`}
          >
            {t("INVOICE.pay")}
          </button>
        }
      >
        <div className="px-4 py-2">
          {invoiceDetail?.description != "" && showDescription && (
            <div>
              {invoiceDetail?.description && (
                <div
                  className="font-poppins font-normal text-sm text-psp-nav text-justify"
                  dangerouslySetInnerHTML={{
                    __html:
                      invoiceDetail?.description?.length > 100 && !isShowMore
                        ? invoiceDetail?.description
                            .replaceAll(/\n/g, "<br>")
                            .substring(0, 100) + "..."
                        : invoiceDetail?.description.replaceAll(/\n/g, "<br>"),
                  }}
                ></div>
              )}
              <h1 className="font-poppins font-normal text-sm text-psp-nav text-justify">
                {/* {invoiceDetail?.description?.length > 100
                    ? isShowMore
                      ? invoiceDetail?.description
                      : invoiceDetail?.description?.substring(0, 100) + "..."
                    : invoiceDetail?.description} */}
                {invoiceDetail?.description?.length > 100 && (
                  <span
                    className="text-blue-600 underline cursor-pointer"
                    onClick={() => setIsShowMore(!isShowMore)}
                  >
                    {isShowMore ? t("INVOICE.showLess") : t("INVOICE.showMore")}
                  </span>
                )}
              </h1>
            </div>
          )}
          <h1 className="font-poppins font-medium text-sm text-black my-2">
            {t("INVOICE.paymentData")}
          </h1>
          <div
            className={`grid grid-cols-2 gap-1 ${
              user.name === invoiceDetail?.callerName ? "hidden" : ""
            }`}
          >
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.parentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
              <div className="grow text-right">{user.name}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.studentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
              <div className="font-poppins grow text-right">
                {invoiceDetail?.callerName}
              </div>
            </div>
          </div>
          <div>
            <h1 className="font-poppins font-medium text-sm text-black my-2">
              {t("INVOICE.detailInvoice")}
            </h1>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceName")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
                <div className="grow text-right">{invoiceDetail?.title}</div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.date")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(invoiceDetail?.invoiceDate).format("LL")}
                </div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.limit")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(invoiceDetail?.dueDate).format("LL")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceType")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetail?.partialMethod == false
                    ? t("INVOICE.cash")
                    : t("INVOICE.credit")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  Status
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetail?.status == "UNPAID"
                    ? t("INVOICE.unpaid")
                    : invoiceDetail?.status == "PAID"
                    ? t("INVOICE.paid")
                    : t("INVOICE.partial")}
                </div>
              </div>
            </div>
            <div hidden={!invoiceDetail?.showDetail}>
              {invoiceDetail?.detail?.map((res: any) => (
                <div className="grid grid-cols-2 gap-1">
                  <div className="flex flex-row">
                    <h1 className="font-poppins font-normal text-sm text-psp-nav">
                      {res.title}
                    </h1>
                  </div>
                  <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                    <div className="grow text-right">
                      {formatCurrency(res.amount)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <hr />
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.amount")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(invoiceDetail?.amount)}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.paid")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-yellow-400 text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(invoiceDetail?.paidAmount)}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.minus")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-rose-600 text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  invoiceDetail?.amount - invoiceDetail?.paidAmount
                )}
              </div>
            </div>
          </div>
          <div
            hidden={!invoiceDetail.partialMethod}
            className="flex flex-col gap-1 mb-2"
          >
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.inputAmount")}
              </h1>
            </div>

            <CurrencyInput
              className="px-3 rounded-xl h-10 border-1 border-psp-border-gray border-solid active:border-0"
              placeholder={placeholder}
              decimalsLimit={2}
              prefix={"Rp "}
              value={
                invoiceDetail?.amount - invoiceDetail?.paidAmount <= 10000
                  ? invoiceDetail?.amount - invoiceDetail?.paidAmount
                  : undefined
              }
              disabled={
                invoiceDetail?.amount - invoiceDetail?.paidAmount <= 10000
              }
              onValueChange={(value, name) => {
                setAmount(value || "");
                value == undefined ? setIsActive(true) : setIsActive(false);
              }}
            />
          </div>
        </div>
      </BottomSheet>
      {/* invoice payment success invoice */}

      <BottomSheet
        open={openPaymentSuccessInvoice}
        onDismiss={onDismissPaymentSuccessInvoice}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.8,
        ]}
        header={""}
        footer={
          <div className="flex flex-col gap-2 z-[1000]">
            {/* <button className="disabled:bg-psp-gray w-full bg-white shadow-lg  text-psp-primary  border-1 border-psp-primary border-solid py-2.5 text-sm font-semibold rounded-lg">
              {t("INVOICE.share")}
            </button> */}
            <button
              onClick={onClick}
              style={{ backgroundColor: customApp?.app_accent_color }}
              className={`disabled:bg-psp-gray w-full  shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp.app_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("INVOICE.download")}
            </button>
            <button
              onClick={() => onDismissPaymentSuccessInvoice()}
              style={{ backgroundColor: customApp?.app_secondary_accent_color }}
              className={`disabled:bg-psp-gray w-full shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp.app_secondary_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("OTHER.close")}
            </button>
          </div>
        }
      >
        {invoiceDetail?.description != "" && showDescription && (
          <div>
            {invoiceDetail?.description && (
              <div
                className="font-poppins font-normal text-sm text-psp-nav text-justify"
                dangerouslySetInnerHTML={{
                  __html:
                    invoiceDetail?.description?.length > 100 && !isShowMore
                      ? invoiceDetail?.description
                          .replaceAll(/\n/g, "<br>")
                          .substring(0, 100) + "..."
                      : invoiceDetail?.description.replaceAll(/\n/g, "<br>"),
                }}
              ></div>
            )}
            <h1 className="font-poppins font-normal text-sm text-psp-nav text-justify">
              {/* {invoiceDetail?.description?.length > 100
                  ? isShowMore
                    ? invoiceDetail?.description
                    : invoiceDetail?.description?.substring(0, 100) + "..."
                  : invoiceDetail?.description} */}
              {invoiceDetail?.description?.length > 100 && (
                <span
                  className="text-blue-600 underline cursor-pointer"
                  onClick={() => setIsShowMore(!isShowMore)}
                >
                  {isShowMore ? t("INVOICE.showLess") : t("INVOICE.showMore")}
                </span>
              )}
            </h1>
          </div>
        )}
        <div className="px-4 py-2 bg-white" ref={ref}>
          <div className="flex flex-col items-center gap-1 mb-6">
            <img className="w-24 h-24 mb-1" src={paymentSuccess} alt="" />
            <h1 className="m-0 font-montserrat text-2xl font-medium">
              {t("INVOICE.success")}
            </h1>
            <span className="font-montserrat text-sm text-psp-nav font-light">
              {t("INVOICE.date")} :{" "}
              {moment(detailPaymentSuccess.dateTime).format("LLL")}
            </span>
          </div>
          <h1 className="font-poppins font-medium text-sm text-black my-2">
            {t("INVOICE.paymentData")}
          </h1>
          <div
            className={`grid grid-cols-2 gap-1 ${
              user.name === invoiceDetail?.callerName ? "hidden" : ""
            }`}
          >
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.parentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
              <div className="grow text-right">{user.name}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.studentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
              <div className="font-poppins grow text-right">
                {invoiceDetail?.callerName}
              </div>
            </div>
          </div>
          <div>
            <h1 className="font-poppins font-medium text-sm text-black my-2">
              {t("INVOICE.detailInvoice")}
            </h1>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceName")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
                <div className="grow text-right">{invoiceDetail?.title}</div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.payDate")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(detailPaymentSuccess.dateTime).format("LL")}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceType")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetail?.partialMethod == false
                    ? t("INVOICE.cash")
                    : t("INVOICE.credit")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  Status
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetail?.status == "UNPAID"
                    ? t("INVOICE.unpaid")
                    : invoiceDetail?.status == "PAID"
                    ? t("INVOICE.paid")
                    : detailPaymentSuccess?.inquiryResponseDto?.amount -
                        (detailPaymentSuccess?.inquiryResponseDto?.paidAmount +
                          detailPaymentSuccess?.amount) ==
                      0
                    ? t("INVOICE.paid")
                    : t("INVOICE.partial")}
                </div>
              </div>
            </div>
            <div hidden={!invoiceDetail?.showDetail}>
              {invoiceDetail?.detail?.map((res: any) => (
                <div className="grid grid-cols-2 gap-1">
                  <div className="flex flex-row">
                    <h1 className="font-poppins font-normal text-sm text-psp-nav">
                      {res.title}
                    </h1>
                  </div>
                  <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                    <div className="grow text-right">
                      {formatCurrency(res.amount)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <hr />
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.total")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  detailPaymentSuccess?.inquiryResponseDto?.amount
                )}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.totalpay")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(detailPaymentSuccess?.amount)}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.minus")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-rose-600 text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  detailPaymentSuccess?.inquiryResponseDto?.amount -
                    (detailPaymentSuccess?.inquiryResponseDto?.paidAmount +
                      detailPaymentSuccess?.amount)
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-2 mb-3">
            {/* <div className="flex flex-row gap-2 justify-center">
              <FacebookShareButton
                ref={shareButton}
                // Disable calling the dialog if we don't have a url yet.
                openShareDialogOnClick={url !== "none"}
                url={"https://teknologikartu.com"}
                onClick={onClick}
              >
                <FacebookIcon size={32} round={true} />
              </FacebookShareButton>
              <WhatsappShareButton
                ref={shareButton}
                // Disable calling the dialog if we don't have a url yet.
                openShareDialogOnClick={url !== "none"}
                url={url}
                onClick={onClick}
              >
                <WhatsappIcon size={32} round={true} />
              </WhatsappShareButton>
              <TelegramShareButton
                ref={shareButton}
                // Disable calling the dialog if we don't have a url yet.
                openShareDialogOnClick={url !== "none"}
                url={url}
                onClick={onClick}
              >
                <TelegramIcon size={32} round={true} />
              </TelegramShareButton>
            </div> */}
          </div>
        </div>
      </BottomSheet>

      {/* sorting */}
      <BottomSheet
        open={openSorting}
        onDismiss={onDismissSorting}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.8,
        ]}
        header={ <h1 className="font-poppins flex items-left text-sm  font-bold text-black">
            {t('INVOICE.sort')}
          </h1>}
        footer={
         ""
        }
      >
      <div className="p-4">
        <div className="flex flex-column gap-2">

          {sortingOptions.map((sort) => (
            <div className="p-4 border-b border-b-silver flex justify-between">
              <label htmlFor={sort.value}>{sort.label}</label>
              <input onChange={(e) => handleSortChange(e)} id={sort.value} name="selectSortBy" checked={sortBy === sort.value}  className="w-5 h-5 border-2 border-psp-primary rounded-full" style={{ accentColor: customApp.app_accent_color }} type="radio" value={sort.value}/>
            </div>
            ))}
          </div>
      </div>
      </BottomSheet>

      <Tab.Group
        onChange={(index) => {
          console.log("Changed selected tab to:", index);
          setActiveTab(index);
        }}
      >
        <Tab.List className="flex space-x-1  bg-white p-1  sticky top-24 ">
          {Object.keys(categories).map((category, key) => (
            <Tab
              key={category}
              style={{
                background: activeTab == key ? customApp.app_accent_color : "",
                color: activeTab == key ? customApp.app_accent_color : "#fff",
              }}
              className={({ selected }) =>
                classNames(
                  "w-full py-2.5 text-sm font-medium",
                  " ",
                  selected
                    ? `font-montserrat rounded-xl text-sm font-semibold ${
                        isDarkColor(customApp.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`
                    : "text-black bg-none font-montserrat text-sm font-semibold"
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>

        {/* invoice */}
        <Tab.Panels>
          {/* data invoice */}
          <Tab.Panel className="p-4 top-to-bottom">
               <button
                  onClick={openSortingMenu}
                  className={`px-3 py-2.5 bg-psp-gray rounded-full font-bold text-xs flex gap-6 items-center ${
                    isDarkColor(customApp.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                      <path fillRule="evenodd" d="M6.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.25 4.81V16.5a.75.75 0 0 1-1.5 0V4.81L3.53 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5Zm9.53 4.28a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V7.5a.75.75 0 0 1 .75-.75Z" clipRule="evenodd" />
                    </svg>


                  {t("INVOICE.sort")}

                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                  </svg>

                </button>
            {invoices.map((res: any) => (
              <div className="bg-white rounded-xl shadow-md font-montserrat my-3">
                <div className="grid grid-row-2 divide-y ">
                  <div className=" pl-3 pt-3 pb-3">
                    <div className="flex flex-row items-center gap-2">
                      <img src={invoice} className="flex-0" />

                      <h1 className="m-0 font-bold text-sm font-montserrat grow">
                        {res.title}
                      </h1>
                      {res.detail[0].discount > 0 ? (
                        <img src={discount} className="flex-0" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="p-3 pt-0">
                    <div className="grid grid-cols-3 mt-3 items-center">
                      <div>
                        <p className="font-montserrat m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.name")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {res.callerName}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.nis")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {res.callerId}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.date")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {moment(res.invoiceDate).format("LL")}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.limit")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {moment(res.dueDate).format("LL")}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.credit")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          :{" "}
                          {res.partialMethod == true
                            ? t("OTHER.yes")
                            : t("OTHER.no")}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.total")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {formatCurrency(res.amount)}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.paid")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {formatCurrency(res.paidAmount)}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mt-3">
                      <div className="flex flex-col">
                        <h1 className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.sisa")}
                        </h1>
                        <p className="m-0 text-sm font-bold text-black">
                          {formatCurrency(res.amount - res.paidAmount)}
                        </p>
                      </div>
                      <button
                        onClick={() => navigate(`/invoicedetail/${res.invoiceId}`)}
                        style={{ backgroundColor: customApp?.app_accent_color }}
                        className={`px-2 py-2.5 rounded-lg font-bold text-xs active:bg-psp-active ${
                          isDarkColor(customApp.app_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                      >
                        {t("INVOICE.pay")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {currentSizeInvoice < 10 ? (
              ""
            ) : (
              <div className="flex w-full">
                <button
                  onClick={addMoreInvoice}
                  style={{ background: customApp?.app_accent_color }}
                  className={`w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active ${
                    isDarkColor(customApp.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {t("OTHER.showMore")}
                </button>
              </div>
            )}
          </Tab.Panel>

          {/* data history  */}
          <Tab.Panel className="p-4 top-to-bottom">
            {invoicePaid.map((res: any) => (
              <div className="bg-white rounded-xl shadow-md font-montserrat my-3">
                <div className="grid grid-row-2 divide-y ">
                  <div className=" pl-3 pt-3 pb-3">
                    <div className="flex flex-row items-center gap-2">
                      <img src={invoice} className="flex-0" />
                      <h1 className="m-0 font-bold text-sm font-montserrat grow">
                        {res.title}
                      </h1>
                      {res.detail[0].discount > 0 ? (
                        <img src={discount} className="flex-0" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="p-3 pt-0">
                    <div className="grid grid-cols-3 mt-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.name")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {res.callerName}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.nis")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {res.callerId}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.date")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {moment(res.invoiceDate).format("LL")}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.limit")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {moment(res.dueDate).format("LL")}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.credit")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          :{" "}
                          {res.partialMethod == true
                            ? t("OTHER.yes")
                            : t("OTHER.no")}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.paid")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          : {formatCurrency(res.paidAmount)}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mt-3">
                      <div className="flex flex-col">
                        <h1 className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.total")}
                        </h1>
                        <p className="m-0 text-sm font-bold text-black">
                          {formatCurrency(res.paidAmount - res.amount)}
                        </p>
                      </div>
                      <button
                        onClick={() => openSheetDetailHistory(res)}
                        style={{ backgroundColor: customApp?.app_accent_color }}
                        className={`px-2 py-2.5 rounded-lg font-bold text-xs ${
                          isDarkColor(customApp.app_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                      >
                        Detail
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {currentSizeInvoicePaid < 10 ? (
              ""
            ) : (
              <div className="flex w-full">
                <button
                  onClick={addMoreInvoicePaid}
                  style={{ background: customApp?.app_accent_color }}
                  className={`w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active ${
                    isDarkColor(customApp.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {t("OTHER.showMore")}
                </button>
              </div>
            )}
          </Tab.Panel>
          <Tab.Panel className="top-to-bottom">
            <div className="bg-white w-full px-4 pt-4">
              <table className="table-auto border-spacing-y-5 border-spacing-x-2 w-full">
                <thead
                  className="border-collapse"
                  style={{
                    backgroundColor: customApp?.app_accent_color,
                    color: isDarkColor(customApp.app_accent_color)
                      ? "white"
                      : "black",
                  }}
                >
                  <tr>
                    <th className="text-xs text-center font-medium px-2 py-1">
                      {t("INVOICE.title")}
                    </th>
                    <th className="text-xs text-center font-medium px-2 py-1">
                      {t("INVOICE.amount")}
                    </th>
                    <th className="text-xs text-center font-medium px-2 py-1">
                      {t("INVOICE.paid")}
                    </th>
                    <th className="text-xs text-center font-medium px-2 py-1">
                      {t("INVOICE.totalDue")}
                    </th>
                  </tr>
                </thead>
                <tbody className="mt-3 border-spacing-x-2">
                  {invoiceSummary.map((res: any, index: any) => (
                    <tr className="">
                      <td className="text-xs text-black font-light">
                        <div className="flex flex-col my-1 px-1">
                          <h1
                            className="font-montserrat font-medium m-0 "
                            style={{ fontSize: 10 }}
                          >
                            {res.title}
                          </h1>
                          <span
                            style={{ fontSize: 9 }}
                            className="font-montserrat text-xs font-medium text-psp-nav "
                          >
                            {moment(res.createDate).format("D-mm-yyyy / LT")}
                          </span>
                        </div>
                      </td>
                      <td className="font-montserrat text-xs text-blue-700 font-medium text-right px-1">
                        {numberWithCommas(res.amount)}
                      </td>
                      <td className="font-montserrat text-xs text-emerald-500 font-medium text-right px-1">
                        {numberWithCommas(res.paidAmount)}
                        {/* {formatCurrency(res.paidAmount).replace(",00", "")} */}
                      </td>
                      <td className="font-montserrat text-xs text-rose-600 font-medium text-right px-1">
                        {numberWithCommas(res.amount - res.paidAmount)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {currentSizeInvoice < 10 ? (
              ""
            ) : (
              <div className="flex flex-row w-full justify-center mt-3">
                <div className=" bg-white items-center shadow-md flex rounded-full overflow-hidden">
                  <button
                    disabled={page == 0}
                    onClick={() => addMoreInvoiceSummary("prev")}
                    style={{ color: customApp?.app_accent_color }}
                    className="disabled:bg-neutral-200 disabled:text-psp-nav bg-white  rounded-r-xl py-1 px-3 font-montserrat font-medium text-lg  active:text-psp-active"
                  >
                    {"<"}
                  </button>
                  <span className="font-montserrat font-medium text-xs">
                    1/3
                  </span>
                  <button
                    onClick={() => addMoreInvoiceSummary("next")}
                    disabled={currentSizeInvoiceSummary < 10}
                    style={{ color: customApp?.app_accent_color }}
                    className="disabled:bg-neutral-200 disabled:text-psp-nav bg-white rounded-sm px-3 py-1 font-montserrat font-medium text-lg active:text-psp-active"
                  >
                    {">"}
                  </button>
                </div>
              </div>
            )}
            {/* <div className="flex flex-row w-full justify-center">
              <button
                onClick={download}
                style={{ backgroundColor: customApp?.app_accent_color }}
                className=" mt-3 text-white font-bold w-10/12 items-center py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
              >
                {t("INVOICE.download")}
              </button>
            </div> */}
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default ComponentInvoice;
